export default "__VITE_ASSET__B$D4CjoK__"